<template>
  <v-app
    :class="[
      { 'nav-drawer-mini': menuIsVerticalNavMini },
      { 'content-full': appContentWidth === 'full' },
    ]"
    class="content-layout vertical-nav"
  >
    <v-navigation-drawer
      v-if="!menuIsMenuHidden"
      ref="layoutDrawer"
      v-model="isVerticalNavMenuActive"
      app
      :right="$vuetify.rtl"
      mini-variant-width="68"
      :expand-on-hover="menuIsVerticalNavMini"
      width="260"
      class="primary white--text"
    >
      <VerticalNavMenu
        :nav-menu-items="navMenuItems"
        @close-nav-menu="isVerticalNavMenuActive = false"
        @openTaskBar=";(isActiveTaskBar = true), (sharedFolderView = false)"
        @openSharedTaskBar=";(isActiveTaskBar = true), (sharedFolderView = true)"
      ></VerticalNavMenu>
    </v-navigation-drawer>
    <!-- if subheader is Task Management than task drawer is visible and functional with  isActiveTaskBar-->
    <task-bar-drawer
      v-if="navMenuItems.length && navMenuItems[0].subheader === 'Task Management'"
      v-model="isActiveTaskBar"
    >
      <TaskSharedNavMenu
        v-if="sharedFolderView"
        :nav-menu-items="navMenuItems"
        @closeTaskBar=";(isActiveTaskBar = false), (sharedFolderView = false)"
      >
      </TaskSharedNavMenu>

      <TaskNavMenu
        v-else
        :nav-menu-items="navMenuItems"
        @closeTaskBar=";(isActiveTaskBar = false), (sharedFolderView = false)"
      ></TaskNavMenu>
    </task-bar-drawer>
    <v-navigation-drawer
      v-model="launcherDrawer"
      temporary
      app
      right
      width="450"
      style="z-index: 14"
    >
      <div class="text-right my-3 mx-9">
        <v-icon color="dark" @click="launcherDrawer = false">{{ mdiClose }}</v-icon>
      </div>
      <Launcherdrawer @close="launcherDrawer = false" />
    </v-navigation-drawer>
    <!-- <v-navigation-drawer
      v-model="openTaskBar"
      temporary
      overlay-opacity="0.1"
      app
      right
      width="720"
      class="app-task-bar"
    >
      <ViewTaskBar v-if="openTaskBar" />
    </v-navigation-drawer> -->
    <v-navigation-drawer
      v-model="openFieldActivityBar"
      temporary
      overlay-opacity="0.1"
      app
      right
      width="720"
      class="app-task-bar"
    >
      <FieldActivityTabs v-if="openFieldActivityBar" />
    </v-navigation-drawer>

    <!-- TODO: All elevations are to bottom and footer requires shadow on top -->
    <v-app-bar
      v-if="appBarType !== 'hidden'"
      ref="refAppBar"
      app
      :absolute="appBarType === 'static'"
      flat
      :elevate-on-scroll="appBarType !== 'static'"
      :elevation="appBarType !== 'static' ? ($vuetify.theme.isDark ? 4 : 3) : 0"
      class="mx-auto app-bar-static"
      :class="[
        { 'px-5 app-bar-shinked': appBarType === 'fixed' && scrollY },
        { 'bg-blur': appBarIsBlurred && appBarType === 'fixed' && scrollY },
      ]"
    >
      <slot
        name="navbar"
        :isVerticalNavMenuActive="isVerticalNavMenuActive"
        :toggleVerticalNavMenuActive="toggleVerticalNavMenuActive"
        :launcherDrawer="setLauncherDrawer"
      ></slot>
    </v-app-bar>

    <slot name="v-app-content"></slot>

    <v-main>
      <app-content-container>
        <slot></slot>
      </app-content-container>
    </v-main>
    <v-overlay
      :value="$store.state.app.shallContentShowOverlay"
      z-index="4"
      absolute
      class="content-overlay"
    ></v-overlay>

    <v-footer
      v-if="footerType !== 'hidden'"
      app
      inset
      :absolute="footerType === 'static'"
      padless
      :class="{ 'mx-auto': appContentWidth !== 'full' }"
      :color="footerType === 'static' ? 'transparent' : null"
    >
      <div :class="{ 'px-5': footerType === 'fixed' }" class="py-4 w-full">
        <slot name="footer"></slot>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import AppContentContainer from '@core/layouts/components/app-content-container/AppContentContainer.vue'
import { getVuetify } from '@/@core/utils'
import useAppConfig from '@core/@app-config/useAppConfig'
import VerticalNavMenu from '@core/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import TaskNavMenu from '@core/layouts/components/vertical-nav-menu/TaskNavMenu.vue'
import TaskSharedNavMenu from '@core/layouts/components/vertical-nav-menu/TaskSharedNavMenu.vue'
import { useWindowScroll } from '@vueuse/core'
import { mdiClose } from '@mdi/js'
import store from '@/store'
import Launcherdrawer from '@/components/shared-components/Launcherdrawer.vue'
import TaskBarDrawer from '@/@core/layouts/components/vertical-nav-menu/TaskBarDrawer.vue'
import ViewTaskBar from '@/components/task-management/ViewTaskBar.vue'
import FieldActivityTabs from '@/components/field-management/FieldActivityTabs.vue'

export default {
  components: {
    AppContentContainer,
    VerticalNavMenu,
    Launcherdrawer,
    TaskNavMenu,
    TaskSharedNavMenu,
    TaskBarDrawer,
    FieldActivityTabs,
    ViewTaskBar,
  },
  props: {
    navMenuItems: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const launcherDrawer = ref(false)
    const setLauncherDrawer = () => {
      launcherDrawer.value = !launcherDrawer.value
    }
    const group = ref(false)
    /* eslint-disable object-curly-newline, operator-linebreak */
    const {
      menuIsVerticalNavMini,
      menuIsMenuHidden,
      appBarType,
      appBarIsBlurred,
      footerType,
      appContentWidth,
    } = useAppConfig()
    const $vuetify = getVuetify()

    const isVerticalNavMenuActive = ref(true)
    const isActiveTaskBar = ref(false)
    const sharedFolderView = ref(false)

    watch(
      () => isVerticalNavMenuActive.value,
      () => {
        if (!isVerticalNavMenuActive.value) {
          isActiveTaskBar.value = false
        }
      },
    )
    // TODO: Check do we need below watch
    watch(
      () => $vuetify?.breakpoint.mdAndDown,
      value => {
        isVerticalNavMenuActive.value = !value
      },
      {
        immediate: true,
      },
    )

    const toggleVerticalNavMenuActive = () => {
      isVerticalNavMenuActive.value = !isVerticalNavMenuActive.value
    }

    const { y: scrollY } = useWindowScroll()

    const openTaskBar = computed({
      get() {
        return store.getters['taskManagement/getOpenTaskBar']
      },
      set(value) {
        store.commit('taskManagement/SET_OPEN_BAR', value)
      },
    })

    const openFieldActivityBar = computed({
      get() {
        return store.getters['fieldManagement/GET_FIELD_ACTIVITY_BAR']
      },
      set(value) {
        store.commit('fieldManagement/SET_FIELD_ACTIVITY_BAR', value)
      },
    })

    return {
      openFieldActivityBar,
      openTaskBar,
      isVerticalNavMenuActive,
      toggleVerticalNavMenuActive,
      menuIsVerticalNavMini,
      menuIsMenuHidden,
      appBarType,
      appBarIsBlurred,
      footerType,
      appContentWidth,
      scrollY,
      launcherDrawer,
      group,
      isActiveTaskBar,
      setLauncherDrawer,
      sharedFolderView,
      //
      mdiClose,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/layouts/styles/_variables';

.app-content-container {
  // padding: $content-padding-vertical-navigation-menu;
  padding: 1rem;
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

// Vuetify Fix
// https://github.com/vuetifyjs/vuetify/issues/13327
$nav-drawer-mini-width: 68px;

.v-application {
  .v-main,
  .v-footer {
    transition-duration: 0.3s;
  }

  .v-footer {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  @include theme(v-footer) using ($material) {
    // Elevation 3 with -y
    &.v-footer--fixed {
      box-shadow: 0 -4px 8px -4px rgba(map-deep-get($material, 'shadow-color'), 0.42) !important;
    }
  }

  &.nav-drawer-mini {
    .v-main {
      // We haven't used `ltr` & `rtl` mixin because those doesn't work with top-level selectors: https://github.com/vuetifyjs/vuetify/issues/13987
      @at-root {
        .nav-drawer-mini {
          &.v-application--is-ltr {
            .v-main {
              padding-left: $nav-drawer-mini-width !important;
            }
          }
          &.v-application--is-rtl {
            .v-main {
              padding-right: $nav-drawer-mini-width !important;
            }
          }
        }
      }
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      .app-navigation-menu ~ .v-footer,
      .app-navigation-menu + .v-app-bar {
        left: $nav-drawer-mini-width !important;
      }
    }
  }

  .v-app-bar,
  .v-footer {
    max-width: calc(1440px - (1.5rem * 2));
    @media screen and (max-width: 1456px) {
      margin-left: 1.5rem !important;
      margin-right: 1.5rem !important;
    }

    @at-root .v-application {
      &.content-full {
        .v-footer,
        .v-app-bar {
          max-width: unset;
          margin-left: $content-padding-vertical-navigation-menu !important;
          margin-right: $content-padding-vertical-navigation-menu !important;
        }
      }

      &:not(.nav-drawer-mini) {
        @media screen and (max-width: 1711px) {
          .app-navigation-menu ~ .v-footer,
          .app-navigation-menu + .v-app-bar {
            margin-left: 1.5rem !important;
            margin-right: 1.5rem !important;
          }
        }
      }
      &.nav-drawer-mini {
        @media screen and (max-width: 1523px) {
          .v-footer,
          .v-app-bar {
            margin-left: 1.5rem !important;
            margin-right: 1.5rem !important;
          }
        }
      }
    }
  }

  .v-app-bar {
    border-radius: 0 0 10px 10px !important;
    z-index: 5;

    &.v-toolbar:not(.app-bar-shinked) {
      background-color: transparent;
    }

    &.app-bar-static {
      will-change: padding, background-color;
      transition: padding 0.2s ease, background-color 0.18s ease, left 0.3s ease;

      &.v-toolbar.v-sheet:not(.v-app-bar--is-scrolled) {
        box-shadow: none !important;
      }

      ::v-deep > .v-toolbar__content {
        padding: 0;
      }
    }
  }
}

@include theme(v-app-bar) using ($material) {
  &.v-toolbar.app-bar-shinked {
    background-color: map-deep-get($material, 'cards');
  }
}

.v-application.content-layout {
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .v-main,
    .v-footer,
    .v-app-bar {
      max-width: unset;
      left: 0 !important;
      @include ltr() {
        padding-left: 0 !important;
      }
      @include rtl() {
        padding-right: 0 !important;
      }
    }
  }
}
</style>
